/**
 * Marketing report type definitions used across the reports feature.
 */

export const MARKETING_REPORT_DEFAULT_VERSION = 1 as const;
export const MARKETING_REPORT_DEFAULT_TYPE = 'MARKETING_V2' as const;

export type MarketingReportTimeRangeType = 'LAST_FULL_MONTH' | 'CUSTOM';

export interface MarketingReportTimeRange {
  type: MarketingReportTimeRangeType;
  start?: string;
  end?: string;
}

export interface ReportGenerationRequestPayload {
  version?: number;
  reportType?: string;
  timeRange: MarketingReportTimeRange;
  locale?: string;
  includeBenchmarks?: boolean;
  templateId?: string | null;
}

export type ReportJobStatus = 'pending' | 'processing' | 'ready' | 'failed';

export type GenerateReportStatus = 'idle' | 'submitting' | ReportJobStatus;

export interface ReportGenerationJobResponse {
  version?: number;
  reportType: string;
  jobId: string;
  status: ReportJobStatus;
}

export interface ReportGenerationJobStatusResponse {
  jobId: string;
  status: ReportJobStatus;
  downloadUrl?: string | null;
  expiresAt?: string | null;
  errorCode?: string | null;
  errorMessage?: string | null;
}

export interface ReportDownloadResponse {
  jobId: string;
  downloadUrl: string;
  expiresAt?: string | null;
}
